// extracted by mini-css-extract-plugin
export default {"spinner":"App_spinner__Qd2xP"};